// Libs
import classNames from 'classnames/bind';
import { Box, InputLabel, TextField } from '@mui/material';
import { ChangeEvent } from 'react';
// Components, Layouts, Pages
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { formatPhoneNumber } from '~/utils/helper/common';
// Styles, images, icons
import styles from './BaseInputPhone.module.scss';

type Props = {
  label?: string;
  name?: string;
  width?: number | string;
  height?: number | string;
  value?: string;
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  errorMessage?: string;
  onChange?: (value: string) => void;
};

const cx = classNames.bind(styles);

const BaseInputPhone = (props: Props) => {
  //#region Destructuring Props
  const {
    label,
    name,
    width,
    height = 35,
    value,
    required = false,
    disabled = false,
    readOnly,
    errorMessage,
    onChange,
  } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleInputPhoneChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    const formattedValue = formatPhoneNumber(value);

    onChange && onChange(formattedValue);
  };
  //#endregion Handle Function

  return (
    <Box component={'div'} id='baseInputPhoneComponent' className={cx('container')}>
      {label && (
        <InputLabel required={required} className={cx('label')}>
          {label}
        </InputLabel>
      )}

      <TextField
        fullWidth
        sx={{ width }}
        type={'text'}
        slotProps={{
          input: {
            className: cx('textFieldInput', { disabled: disabled }),
            sx: { height },
            readOnly,
          },
          formHelperText: { className: cx('errorMessage') },
        }}
        name={name}
        value={value || EMPTY_STRING}
        disabled={disabled}
        onChange={handleInputPhoneChange}
        error={!!errorMessage}
        helperText={errorMessage}
      />
    </Box>
  );
};

export default BaseInputPhone;
